// extracted by mini-css-extract-plugin
export default {"input":"NumberInput_input__p0Fu5","lg":"NumberInput_lg__WlDvn","short":"NumberInput_short__OTk40"};